import {Routes, Route} from 'react-router-dom';
import SupervisedLearningIntro from "./SupervisedLearningIntro";
import LinearRegression from "./LinearRegression";
import ClassificationRoutes from "./Classification/ClassficationRoutes";

const MachineLearningRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<SupervisedLearningIntro/>}/>
                <Route path="/linear-regression" element={<LinearRegression/>}/>
                <Route path="/classification/*" element={<ClassificationRoutes/>}/>
            </Routes>
        </>
    )
}

export default MachineLearningRoutes;